import { styled } from '@betterment/samba-styled-system/jsx';

export const FooterLink = styled('a', {
  base: {
    textDecoration: 'underline',
    fontSize: 'fontSize.50',
    lineHeight: 'lineHeight.30',
    color: 'text.weak',
  },
});
